import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { AuthenticationService } from '../shared/authentication.service';
import { ApiService } from '../shared/api.service';
import { FormControl } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { EbiService } from '../shared/ebi.service';
import { Email } from '../email-template/email-template.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-location-detail',
  templateUrl: './location-detail.component.html',
  styleUrls: ['./location-detail.component.css']
})
export class LocationDetailComponent implements OnInit, OnDestroy {

  place: any;
  placeId: string;
  idToken;
  uid;
  userRole;
  userData;
  userSavedPlaces: Array<any>;
  userOrgData;
  userSavedWaterSources;
  userTests;
  loaded = false;
  markerOptions = {
    animation: google.maps.Animation.DROP,
    icon: './assets/icon.png'
  };
  testTypes = new FormControl();
  currentLocationTests: Array<any>;
  testsToDisplay: Array<any>;
  testTypesList: string[] = ['Bacteria', 'Lead', 'Chlorine', 'Ecoli', 'C19', 'H2O2'];
  testFilters: Array<any>;
  startDateFilter;
  userEmail;
  email: Email;
  endDateFilter;
  @ViewChild('typeSelect') typeSelect: MatSelect;
  otherOrgId: string;
  private authStateSubscription: Subscription;
  position;

  constructor(private route: ActivatedRoute, private apiService: ApiService, private router: Router,
              private angularFireAuth: AngularFireAuth, private ebiService: EbiService,
              private authenticationService: AuthenticationService) {
    this.place = this.router.getCurrentNavigation().extras?.state?.place;
    this.otherOrgId = this.router.getCurrentNavigation().extras?.state?.itemOrg;
  }


  async ngOnInit(): Promise<void> {
    this.authStateSubscription = this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {
        this.userData = this.authenticationService.userData;
        this.userRole = this.authenticationService.userRole;
        this.uid = this.userData.uid;
        this.userEmail = this.userData.email;
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        console.log(this.place);
        await this.getUserSavedData();
        if (this.userEmail) {
          this.email = {
            to: [this.userEmail],
            from: 'ExactBlue',
            subject: this.place?.name + ' test results',
            html: '<h3>' + (this.place?.formatted_address || this.place?.name) + '</h3>\n' + '<div class=\'row\'>\n' +
              '          <div class=\'col-12 pb-2\'>\n' +
              '            <small class=\'d-block\'>NUMBER OF TESTS</small>\n' +
              '            <p\n' +
              '              class=\'card-text\'>' + this.place?.numberOfTests + '</p>\n' +
              '\n' +
              '          </div>\n' +
              '          <div class=\'col-12 pb-2\'>\n' +
              '            <small class=\'d-block\'>NUMBER OF WATER SOURCES</small>\n' +
              '            <p\n' +
              '              class=\'card-text\'>' + this.place?.numberOfSources + '</p>\n' +
              '          </div>\n' +
              '        </div>\n' +
              '        <div class=\'row\'>\n' +
              '          <div class=\'col-12 pb-2\'>\n' +
              '            <small class=\'d-block\'>LAST TESTED</small>\n' +
              '            <div class=\'card-text\'><p>\n' +
              '\n' +
              this.place?.lastTested +
              '\n' +
              '            </p></div>\n' +
              '\n' +
              '          </div>\n' +

              '        </div>',
            attachments: ['']
          };
        }


      } else {
        await this.router.navigate(['/']);
      }
    });

  }

  async ngOnDestroy() {
    if (this.authStateSubscription) {
      this.authStateSubscription.unsubscribe();
    }
  }

  /**
   * Gets the user saved data from the database
   */
  async getUserSavedData() {
    this.loaded = false; // show loading spinner
    const userData = await this.apiService.getUserData(this.uid, this.idToken);

    const filters = {filters: {uid: this.uid}};
    this.userTests = await this.apiService.getTestData(filters, this.idToken); // get user tests

    const userCustomClaims = await this.apiService.getUserCustomClaims(this.idToken, this.uid);
    const userOrgId = this.otherOrgId || userCustomClaims.orgData?.orgId || userData.data.orgId;
    this.userOrgData = await this.apiService.getOrgData(this.idToken, userOrgId);
    this.userSavedPlaces = userData.data.places ? userData.data.places : [];
    this.userSavedPlaces = this.userSavedPlaces.filter(place =>
      typeof place.time_created === 'number'
    ).sort((a, b) => b.time_created - a.time_created);
    this.userSavedWaterSources = userData.data.waterSources ? userData.data.waterSources : [];

    // if user is admin and org is sharing locations, or if superuser, get all places in org
    if ((this.userRole === 'admin' && this.userOrgData.sharingLocations) || this.userRole === 'superuser') {
      const userList = await this.apiService.getOrgUsers(this.idToken, this.otherOrgId || userOrgId); // get users in org
      const orgPlacesArray = []; // array of all places in org
      const orgWaterSourcesArray = []; // array of all water sources in org

      // loop through users in org, get places and water sources, add to orgPlaces and orgWaterSources
      for (const orgUser of userList) {
        if (orgUser.userData?.uid !== this.uid) {
          const places = orgUser.userData?.places;
          const sources = orgUser.userData?.waterSources;
          if (places) {
            orgPlacesArray.push(places);
          }
          if (sources) {
            orgWaterSourcesArray.push(sources);
          }
          const testFilters = {filters: {uid: orgUser.userData?.uid}};
          const orgUserTests = await this.apiService.getTestData(testFilters, this.idToken);
          console.log(this.userTests);

          this.userTests.data = this.userTests.data.concat(orgUserTests.data); // add all tests to user tests


        }
      }
      console.log(this.userTests.data);

      for (const orgPlaces of orgPlacesArray) {
        this.userSavedPlaces = this.userSavedPlaces.concat(orgPlaces); // add all places to user places
      }
      for (const orgSources of orgWaterSourcesArray) {
        this.userSavedWaterSources = this.userSavedWaterSources.concat(orgSources); // add all water sources to user water sources
      }
      console.log(this.userSavedPlaces);
    }
    if (!this.place) {
      this.placeId = this.route.snapshot.paramMap.get('id'); // get id from url
      this.place = this.userSavedPlaces.find(place => place.place_id === this.placeId); // find place in user places with id
      if (!this.place) { // if place not found, redirect to locations
        if (this.router.url.includes('location')) {
          await this.router.navigate(['/locations']);
        }
      }
    }
    this.getPlaceTestData(); // get test data for place
    this.position = {lat: this.place?.lat, lng: this.place?.lng}; // set position to place

    this.loaded = true; // hide loading spinner


  }

  handleStartDateChange($event: Event) {
    console.log('here');
    const target = $event.target as HTMLInputElement;
    this.startDateFilter = target.valueAsNumber / 1000;
    console.log(this.startDateFilter);
    const endDateInput = document.getElementById('end') as HTMLInputElement;
    endDateInput.setAttribute('min', target.value);
    this.filterDisplayedTests();
  }

  handleEndDateChange($event: Event) {
    console.log('here');
    const target = $event.target as HTMLInputElement;
    this.endDateFilter = target.valueAsNumber / 1000;
    console.log(this.endDateFilter);
    const endDateInput = document.getElementById('start') as HTMLInputElement;
    endDateInput.setAttribute('max', target.value);
    this.filterDisplayedTests();
  }

  filterTestTypes($event: MatSelectChange) {
    this.testFilters = $event.value.map(filter => filter.toLowerCase());
    this.filterDisplayedTests();
    console.log(this.testFilters);
  }

  filterDisplayedTests() {
    this.testsToDisplay = this.currentLocationTests;
    if (this.testFilters?.length > 0) {
      this.testsToDisplay = this.currentLocationTests.filter(test => {
        return this.testFilters.includes(test.calculationResult.testType.toLowerCase());
      });
    }

    if (this.startDateFilter) {
      this.testsToDisplay = this.testsToDisplay.filter(test => {
        console.log(this.startDateFilter, test.calculationResult.date._seconds);
        return test.calculationResult.date._seconds >= this.startDateFilter;
      });

    }
    if (this.endDateFilter) {
      this.testsToDisplay = this.testsToDisplay.filter(test => {
        console.log(this.endDateFilter, test.calculationResult.date._seconds);
        return test.calculationResult.date._seconds <= this.endDateFilter;
      });

    }
  }

  clearFilters() {
    this.startDateFilter = undefined;
    this.endDateFilter = undefined;
    this.testFilters = [];
    const startDateInput = document.getElementById('start') as HTMLInputElement;
    const endDateInput = document.getElementById('end') as HTMLInputElement;
    if (startDateInput) {
      startDateInput.setAttribute('max', '');
      startDateInput.value = '';

    }
    if (endDateInput) {
      endDateInput.setAttribute('min', '');
      endDateInput.value = '';

    }
    this.typeSelect.value = '';
    this.filterDisplayedTests();
  }

  createLocationPDF() {
    this.ebiService.createLocationPdf(this.place, this.testsToDisplay);

  }

  getPlaceTestData() {
    this.place.numberOfSources = this.userSavedWaterSources.filter(source => {
      return source.place_id === this.place?.place_id && source.name;
    }).length;
    console.log(this.place.numberOfSources);
    this.currentLocationTests = this.userTests.data.filter(test => test.location && test.location.place_id === this.place.place_id);
    console.log(this.currentLocationTests);
    this.place.numberOfTests = this.currentLocationTests.length;
    this.place.lastTested = this.currentLocationTests.length > 0 ? new Date(this.currentLocationTests.sort((a, b) => b.calculationResult.date?._seconds - a.calculationResult.date?._seconds)[0].calculationResult.date._seconds * 1000).toLocaleDateString('en-US') : 'N/A';
    this.testsToDisplay = this.currentLocationTests;
    this.loaded = true;
  }

  async updateMap() {
    this.place = undefined;
    await this.getUserSavedData();
    // console.log($event);
    // const lat = $event.lat;
    // const lng = $event.lng;
    // this.position = {lat, lng};
  }
}
